import { useSelector } from 'react-redux';
import { toast } from 'sonner';

const useAgentGoalValidator = () => {
  //   const agent = useSelector(state => state.agent.data);
  const campaignType = useSelector(state => state.agent.data.campaignData.campaignType);

  const isGoalNextButtonDisabled = () => {
    if (!campaignType) {
      toast.warning('Pick an agent type');
      return true;
    }

    return false;
  };

  return { isGoalNextButtonDisabled };
};

export default useAgentGoalValidator;
